import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

const MainHeader = () => {
  return (
    <div className="max-w-7xl mx-auto xxs:px-4 sm:px-6 lg:px-8 my-2">
      <div className="space-y-2 flex flex-col items-center justify-center text-gray-500 dark:text-gray-200 xxs:mb-4">
        <div className="text-3xl font-medium text-center">
          Mizar Copy Trading
        </div>

        <div className="flex space-x-2 uppercase">
          <a
            className="xxs:bg-white-400 hover:bg-white-500 dark:bg-black-600 dark:hover:bg-black-500 rounded xxs:py-1 xxs:px-2 text-sm"
            href="https://docs.mizar.com/c-mizar-manual/copy-trading/how-to-invest"
            target="_blank"
            rel="noreferrer"
          >
            <div className="flex space-x-2 items-center">
              <div className="text-white font-bold lg:hidden">Docs</div>
              <div className="text-white font-bold hidden lg:block">
                Learn How to Invest
              </div>
              <ArrowTopRightOnSquareIcon className="w-4 h-4 text-white" />
            </div>
          </a>
          <a
            className="xxs:bg-white-400 hover:bg-white-500 dark:bg-black-600 dark:hover:bg-black-500 rounded xxs:py-1 xxs:px-2 text-sm"
            href="https://docs.mizar.com/c-mizar-manual/copy-trading/manage-your-public-bots"
            target="_blank"
            rel="noreferrer"
          >
            <div className="flex space-x-2 items-center">
              <div className="text-white font-bold lg:hidden">Docs</div>
              <div className="text-white font-bold hidden lg:block">
                Share Your Bots
              </div>
              <ArrowTopRightOnSquareIcon className="w-4 h-4 text-white" />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MainHeader;
